"use strict";
import { memo } from "react";
import { Trace as UntypedTrace } from "utilities/src/telemetry/trace/Trace";
function _Trace({
  children,
  eventOnTrigger,
  properties,
  logImpression,
  logPress,
  logFocus,
  logKeyPress,
  ...rest
}) {
  const typedProps = properties ? properties : void 0;
  return <UntypedTrace
    eventOnTrigger={eventOnTrigger}
    logFocus={logFocus}
    logImpression={logImpression}
    logKeyPress={logKeyPress}
    logPress={logPress}
    properties={typedProps}
    {...rest}
  >
      {children}
    </UntypedTrace>;
}
const typedMemo = memo;
const Trace = typedMemo(_Trace);
export { Trace };
export default Trace;
